var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../LayoutDesigner/LayoutDesigner", "../LayoutDesigner/LayoutElement", "../ConfigurationDesigner/ConfigurationDesigner", "../Components/NumericInputComponent", "../EventEmitter", "../../lib/interactjs/dist/interact", "vue", "./ContentSelectionController", "../Models/Configuration/RoomOverview", "../Models/Configuration/RoomOverview", "../Models/Configuration/RoomOverview", "../Shared/Rect", "../Shared/NovoNoty", "../Shared/BoundingBox2D"], function (require, exports, LayoutDesigner_1, LayoutElement_1, ConfigurationDesigner_1, NumericInputComponent_1, EventEmitter_1, interact, vue_1, ContentSelectionController_1, RoomOverview_1, RoomOverview_2, RoomOverview_3, Rect_1, NovoNoty_1, BoundingBox2D_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ConfigurationDesignController = (function (_super) {
        __extends(ConfigurationDesignController, _super);
        function ConfigurationDesignController(locationId, roomId) {
            var _this = _super.call(this) || this;
            _this.debug = false;
            _this.layoutTemplate = '<div><div class="kachel"><div class="layout-element"><div class="TvScreenRect"></div></div><hr class="cyb-hr"/><div><span class="main-line">XXXParser</span><br/><span class="sub-line">YYYParser</span></div></div><div></div>';
            _this.vsLayoutTemplate = '<div><div style="height:30px" data-type="header"></div><div data-type="content" style="height:calc(100% - 30px)"></div></div>';
            _this.containerLayoutTemplate = '<div><div style="height:30px" data-type="header"></div><div data-type="content" style="height:calc(100% - 30px)"></div></div>';
            _this.minWorkspaceWidth = 0;
            _this.minWorkspaceHeight = 0;
            _this.currentWorkspaceMaxWidth = 0;
            _this.currentWorkspaceMaxHeight = 0;
            _this.addWorkspaceWidth = 300;
            _this.addWorkspaceHeight = 300;
            _this.maxElementWidth = 800;
            _this.OnConfigurationLoaded = "OnConfigurationLoaded";
            _this.OnCurentScreenDelete = "OnCurentScreenDelete";
            _this.currentLocationId = locationId;
            _this.currentRoomId = roomId;
            _this.virtualScreenElements = new Array();
            var host = _this;
            var nic = new NumericInputComponent_1.NumericInputComponent();
            _this.root = $("#contentWorkSpace");
            _this.currentWorkspaceMaxWidth = _this.root.width();
            _this.minWorkspaceWidth = _this.currentWorkspaceMaxWidth;
            _this.currentWorkspaceMaxHeight = _this.root.height();
            _this.minWorkspaceHeight = _this.currentWorkspaceMaxHeight;
            host.virtualScreenLayoutDesigner = new LayoutDesigner_1.LayoutDesigner(_this.root, "tv");
            host.virtualScreenLayoutDesigner.elementClassName = "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12";
            host.configurationDesigner = new ConfigurationDesigner_1.ConfigurationDesigner(_this.root, "vi");
            host.configurationDesigner.elementClassName = "";
            host.configurationDesigner.elementSelectedClassName = "";
            host.configurationDesigner.containerLayoutTemplate = _this.containerLayoutTemplate;
            host.configurationDesigner.AddEventListener(LayoutElement_1.LayoutElement.OnElementDropped, host.ElementDropped.bind(host));
            host.configurationDesigner.AddEventListener(LayoutElement_1.LayoutElement.OnElementTouched, host.ElementTouched.bind(host));
            host.configurationDesigner.AddEventListener(LayoutElement_1.LayoutElement.OnElementEdit, host.ElementEdit.bind(host));
            host.configurationDesigner.AddEventListener(LayoutElement_1.LayoutElement.OnElementMoved, host.ElementMoved.bind(host));
            host.configurationDesigner.ApplyDropzone("#contentWorkSpace", ".Dragable");
            host.configurationDesigner.AllowDeepEdit = true;
            host.visDebug = new LayoutDesigner_1.LayoutDesigner(_this.root, "visDebug");
            host.visDebug.elementClassName = "DebugPoint";
            host.visDebug.elementSelectedClassName = "DebugPoint";
            host.AddEventListener("MovedOverElement", host.CreateNewVirtualScreenElement.bind(host));
            host.SetupVirtualScreenDataSource();
            host.SetupConfigurationDataSource();
            host.headerVm = new vue_1.default({
                el: '#headerUI',
                data: {
                    vsName: "",
                    vsDimension: "",
                    vsComment: null,
                    vsCount: 0
                },
                methods: {
                    DeactivateAllScreens: function (event) {
                        host.DeactivateAllScreens();
                        host.SaveVirtualScreens();
                        host.SaveRoomOverview();
                    },
                    ActivateAllScreens: function (event) {
                        host.ActivateAllScreens();
                        host.SaveVirtualScreens();
                        host.SaveRoomOverview();
                    }
                }
            });
            host.rootVm = new vue_1.default({
                el: '#contentEditorUI',
                data: {
                    xPos: 0,
                    yPos: 0
                },
                methods: {
                    Save: function (event) {
                        console.log("Save");
                        host.SaveVirtualScreens();
                        host.SaveRoomOverview();
                    },
                    Load: function (event) {
                        console.log("Load");
                        host.Load();
                    },
                    DeleteLayoutElement: function (event) {
                        console.log("DeleteLayoutElement");
                        if (host.configurationDesigner.SelectedElement == null) {
                            NovoNoty_1.NovoNoty.ShowError("Bitte selektieren Sie zuerst einen TV-Screen oder eine Video-Wall.");
                            return;
                        }
                        host.ShowVirtualScreenElement(host.configurationDesigner.SelectedElement);
                        host.configurationDesigner.DeleteLayoutElementRecursively(host.configurationDesigner.SelectedElement);
                        var index = host.virtualScreenElements.indexOf(host.configurationDesigner.SelectedElement);
                        if (index != -1) {
                            host.virtualScreenElements.splice(index, 1);
                        }
                        host.SetVirtualScreenCanvasVisibility();
                        host.FireEvent(host.OnCurentScreenDelete);
                    },
                    UpdatePosX: function (childVm, value) {
                        console.log("UpdatePosX: " + value);
                    },
                    UpdatePosY: function (childVm, value) {
                        console.log("UpdatePosY: " + value);
                    }
                }
            });
            _this.remoteControl = new vue_1.default({
                el: '#remoteControl',
                data: {
                    currentScreen: null,
                    opened: false
                },
                computed: {
                    isAScreenSelected: function () {
                        return this.currentScreen !== null && this.currentScreen !== undefined;
                    },
                    isCurrentScreenOff: function () {
                        if (!this.isAScreenSelected)
                            return false;
                        else
                            return this.currentScreen.object.VirtualScreen.State === "off";
                    }
                },
                methods: {
                    toggleCollapse: function () {
                        if (this.opened)
                            this.opened = false;
                        else
                            this.opened = true;
                    },
                    commandBuilder: function (command, commandType, remoteType) {
                        if (commandType === void 0) { commandType = 'remote'; }
                        if (remoteType === void 0) { remoteType = 'infrared'; }
                        return {
                            CommandType: commandType,
                            RemoteType: remoteType,
                            Command: command
                        };
                    },
                    volumeUp: function () {
                        this.sendScreenCommand(host.configurationDesigner.SelectedElement, this.commandBuilder('volumeup'));
                    },
                    volumeDown: function () {
                        this.sendScreenCommand(host.configurationDesigner.SelectedElement, this.commandBuilder('volumedown'));
                    },
                    inputSelect: function () {
                        this.sendScreenCommand(host.configurationDesigner.SelectedElement, this.commandBuilder('inputselect'));
                    },
                    togglePower: function () {
                        if (host.configurationDesigner.SelectedElement == null) {
                            if (host.debug)
                                console.log("remote control: no screen selected");
                            return false;
                        }
                        var screen = host.configurationDesigner.SelectedElement;
                        var screenModel = screen.object.VirtualScreen;
                        screenModel.State = (screenModel.State === 'on') ? 'off' : 'on';
                        screen.UpdateStateUI();
                        $.ajax({
                            url: "/api/v1/virtualscreens/" + screen.object.VirtualScreen.Id + "/state/" + screenModel.State,
                            type: "put", contentType: "application/json",
                        }).then(function (response) {
                        }, function (response) {
                            new Noty({
                                text: "Der Behehl konnte leider nicht verarbeitet werden",
                                type: 'error',
                                theme: 'metroui',
                                timeout: 6000
                            }).show();
                        });
                    },
                    power: function () {
                        this.sendScreenCommand(host.configurationDesigner.SelectedElement, this.commandBuilder('tvpower'));
                    },
                    mute: function () {
                        this.sendScreenCommand(host.configurationDesigner.SelectedElement, this.commandBuilder('mute'));
                    },
                    sendScreenCommand: function (screen, command) {
                        if (screen == null) {
                            if (host.debug)
                                console.log("remote control: no screen selected");
                            return false;
                        }
                        $.ajax({
                            url: "/api/v1/virtualscreens/" + screen.object.VirtualScreen.Id + "/command",
                            type: "post", contentType: "application/json",
                            data: JSON.stringify(command)
                        }).then(function (response) {
                        }, function (response) {
                            new Noty({
                                text: "Der Behehl konnte leider nicht verarbeitet werden",
                                type: 'error',
                                theme: 'metroui',
                                timeout: 6000
                            }).show();
                        });
                    }
                }
            });
            host.configurationDesigner.AddEventListener(host.configurationDesigner.OnElementSelected, function (sender, screen) {
                _this.remoteControl.currentScreen = screen;
            });
            host.configurationDesigner.AddEventListener(host.configurationDesigner.OnElementDeselected, function (sender, screen) {
                _this.remoteControl.currentScreen = screen;
            });
            host.AddEventListener(host.OnCurentScreenDelete, function (sender, screen) {
                _this.remoteControl.currentScreen = null;
            });
            _this.AddEventListener(_this.OnConfigurationLoaded, function (sender, data) {
                if (_this.debug)
                    console.log("Data fetched");
                if (_this.virtualScreenElements.length != 1)
                    return;
                var layoutElement = _this.virtualScreenElements[0];
                _this.configurationDesigner.SelectElement(layoutElement);
                var virtualScreen = layoutElement.object.VirtualScreen;
                _this.SetInfoGui(virtualScreen);
            });
            _this.configDataSource.read();
            return _this;
        }
        ConfigurationDesignController.prototype.SetupConfigurationDataSource = function () {
            var host = this;
            host.configDataSource = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: "/api/v1/gui/roomoverview/" + host.currentRoomId,
                        type: "get", dataType: "json"
                    },
                    create: {
                        url: "/api/v1/gui/roomoverview",
                        type: "post", dataType: "json", contentType: "application/json"
                    },
                    update: {
                        url: "/api/v1/gui/roomoverview",
                        type: "put", dataType: "json", contentType: "application/json"
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== "read" && data) {
                            return kendo.stringify(data);
                        }
                    }
                },
                schema: {
                    type: "json",
                    model: {
                        id: "Id",
                        fields: { Id: "Id" }
                    }
                },
                change: function (e) {
                    if (this.debug) {
                        console.log("change");
                        console.log(e.items[0]);
                    }
                },
                requestEnd: function (e) {
                    if (e.type === undefined)
                        return;
                    if (this.debug) {
                        console.log("requestEnd");
                        console.log(e);
                    }
                    var response = e.response;
                    var type = e.type;
                    if (type === "read") {
                        host.CreateConfiguration(response);
                        host.vsDataSource.read();
                        host.FireEvent(host.OnConfigurationLoaded, host);
                    }
                    else {
                        if (e.response != undefined)
                            NovoNoty_1.NovoNoty.Show("Der Befehl wurde erfolgreich ausgeführt.");
                    }
                },
                error: function (e) {
                    if (this.debug) {
                        console.log("SetupConfigurationDataSource RemoteDataSource Error");
                        console.log(e.status);
                    }
                    NovoNoty_1.NovoNoty.ShowErrorDetails(e);
                }
            });
        };
        ConfigurationDesignController.prototype.SetupVirtualScreenDataSource = function () {
            var host = this;
            host.vsDataSource = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: "/api/v1/rooms/" + host.currentRoomId + "/virtualscreens",
                        type: "get", dataType: "json"
                    },
                    create: {
                        url: "/api/v1/virtualscreens",
                        type: "post", dataType: "json", contentType: "application/json"
                    },
                    update: {
                        url: "/api/v1/virtualscreens",
                        type: "put", dataType: "json", contentType: "application/json"
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== "read" && data) {
                            return kendo.stringify(data);
                        }
                    }
                },
                schema: {
                    type: "json",
                    model: {
                        id: "Id",
                        fields: { Id: "Id" }
                    }
                },
                change: function (e) {
                    if (this.debug) {
                        console.log("change");
                        console.log(e.items[0]);
                    }
                },
                requestEnd: function (e) {
                    if (this.debug) {
                        console.log("requestEnd");
                        console.log(e);
                    }
                    var response = e.response;
                    var type = e.type;
                    if (type === "read") {
                        host.CreateVirtualScreens(response);
                        host.SetCommonGui(response);
                    }
                },
                error: function (e) {
                    if (this.debug) {
                        console.log("SetupVirtualScreenDataSource RemoteDataSource Error");
                        console.log(e.status);
                    }
                    NovoNoty_1.NovoNoty.ShowErrorDetails(e);
                }
            });
        };
        ConfigurationDesignController.prototype.VisDebug = function (timestamp) {
            this.visDebug.ClearAllElements();
            var elements = this.configurationDesigner.GetElements();
            if (elements != null && elements.length > 0)
                for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
                    var element = elements_1[_i];
                    if (element != null) {
                        this.visDebug.CreateLayoutElement(2, 2, element.position.x, element.position.y, this.root);
                        this.visDebug.CreateLayoutElement(2, 2, element.boundingBox.min.x, element.boundingBox.min.y, this.root);
                        this.visDebug.CreateLayoutElement(2, 2, element.boundingBox.max.x, element.boundingBox.max.y, this.root);
                        console.log("element.boundingBox.min.x: " + element.boundingBox.min.x);
                    }
                }
            window.requestAnimationFrame(this.VisDebug.bind(this));
        };
        ConfigurationDesignController.prototype.CreateVirtualScreens = function (virtualScreens) {
            if (this.debug)
                console.log("CreateVirtualScreens");
            var parent = $("#virtualScreenContent");
            for (var _i = 0, virtualScreens_1 = virtualScreens; _i < virtualScreens_1.length; _i++) {
                var virtualScreen = virtualScreens_1[_i];
                if (virtualScreen.State == null)
                    virtualScreen.State = "on";
                var layoutElement = this.virtualScreenLayoutDesigner.CreateLayoutElement(0, 0, 0, 0, parent, this.layoutTemplate, true);
                var description = Math.round(virtualScreen.Dimension.Width) + " x " + Math.round(virtualScreen.Dimension.Height) + " mm";
                layoutElement.SetHtmlContent(virtualScreen.Name, ".main-line");
                layoutElement.SetHtmlContent(description, ".sub-line");
                layoutElement.AddOnMoveEvent(this);
                layoutElement.object = virtualScreen;
                for (var _a = 0, _b = this.virtualScreenElements; _a < _b.length; _a++) {
                    var virtualScreenElement = _b[_a];
                    var virtualScreenInConfig = virtualScreenElement.object.VirtualScreen;
                    if (virtualScreenInConfig.Id == virtualScreen.Id)
                        layoutElement.Hide();
                }
            }
            this.SetVirtualScreenCanvasVisibility();
        };
        ConfigurationDesignController.prototype.SetVirtualScreenCanvasVisibility = function () {
            var children = $("#virtualScreenContent").children().get();
            for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                var child = children_1[_i];
                if (child.style.display != "none") {
                    $("#virtualScreenCanvas").show();
                    $('#workspaceCanvas').attr("style", "");
                    return;
                }
            }
            $("#virtualScreenCanvas").hide();
            $('#workspaceCanvas').attr("style", "width: 100%;max-width: 100%;-ms-flex: 0 0 100%;flex: 0 0 100%;");
        };
        ConfigurationDesignController.prototype.DeactivateAllScreens = function () {
            for (var _i = 0, _a = this.virtualScreenElements; _i < _a.length; _i++) {
                var virtualScreenElement = _a[_i];
                var virtualScreen = virtualScreenElement.object.VirtualScreen;
                virtualScreen.State = "off";
                var virtualScreenContainer = virtualScreenElement;
                virtualScreenContainer.UpdateStateUI();
            }
        };
        ConfigurationDesignController.prototype.ActivateAllScreens = function () {
            for (var _i = 0, _a = this.virtualScreenElements; _i < _a.length; _i++) {
                var virtualScreenElement = _a[_i];
                var virtualScreen = virtualScreenElement.object.VirtualScreen;
                virtualScreen.State = "on";
                var virtualScreenContainer = virtualScreenElement;
                virtualScreenContainer.UpdateStateUI();
            }
        };
        ConfigurationDesignController.prototype.SaveVirtualScreens = function () {
            for (var _i = 0, _a = this.virtualScreenElements; _i < _a.length; _i++) {
                var virtualScreenElement = _a[_i];
                var virtualScreen = virtualScreenElement.object.VirtualScreen;
                var kendoData = this.vsDataSource.get(virtualScreen.Id);
                if (kendoData == null) {
                    console.error("No virtual screen found with id: " + virtualScreen.Id);
                    continue;
                }
                kendoData.Content = virtualScreen.Content;
                if (virtualScreen.State == null)
                    virtualScreen.State = "on";
                kendoData.State = virtualScreen.State;
                kendoData.dirty = true;
            }
            this.vsDataSource.sync();
        };
        ConfigurationDesignController.prototype.SaveRoomOverview = function () {
            var data = this.configDataSource.data();
            if (data == null || data.length == 0) {
                var roomOverview = this.CreateNewRoomOverview();
                this.configDataSource.add(roomOverview);
            }
            else {
                var myData = this.configDataSource.at(0);
                myData.Groups = this.GetOverviewGroups();
                myData.dirty = true;
            }
            this.configDataSource.sync();
        };
        ConfigurationDesignController.prototype.CreateNewRoomOverview = function () {
            var roomOverview = new RoomOverview_1.RoomOverview();
            roomOverview.RoomId = this.currentRoomId;
            roomOverview.Groups = this.GetOverviewGroups();
            return roomOverview;
        };
        ConfigurationDesignController.prototype.GetOverviewGroups = function () {
            var groups = new Array();
            var vsGroup = new RoomOverview_2.VirtualScreenGroup();
            vsGroup.Index = 0;
            vsGroup.Name = "Hauptbereich";
            vsGroup.VirtualScreens = new Array();
            for (var _i = 0, _a = this.virtualScreenElements; _i < _a.length; _i++) {
                var virtualScreenElement = _a[_i];
                var virtualScreenWithPos = virtualScreenElement.object;
                virtualScreenWithPos.X = Math.round(virtualScreenElement.x / this.configurationDesigner.FinalScale);
                virtualScreenWithPos.Y = Math.round(virtualScreenElement.y / this.configurationDesigner.FinalScale);
                vsGroup.VirtualScreens.push(virtualScreenWithPos);
            }
            groups.push(vsGroup);
            return groups;
        };
        ConfigurationDesignController.prototype.Load = function () {
            this.vsDataSource.read();
        };
        ConfigurationDesignController.prototype.GetBoundingBox = function () {
            var boundingBoxes = new Array();
            for (var _i = 0, _a = this.virtualScreenElements; _i < _a.length; _i++) {
                var element = _a[_i];
                boundingBoxes.push(element.boundingBox);
            }
            var vsBoundingBox = BoundingBox2D_1.BoundingBox2D.GetEncapsulatedBounds(boundingBoxes);
            return vsBoundingBox;
        };
        ConfigurationDesignController.prototype.CreateConfiguration = function (data) {
            if (this.debug) {
                console.log("CreateConfiguration");
                console.log(data);
            }
            var roomOverview = data;
            for (var _i = 0, _a = roomOverview.Groups; _i < _a.length; _i++) {
                var group = _a[_i];
                for (var _b = 0, _c = group.VirtualScreens; _b < _c.length; _b++) {
                    var virtualScreenWithPos = _c[_b];
                    this.CreateVirtualScreenElement(virtualScreenWithPos);
                }
            }
            this.ExtendWorkspace(0, 0);
            this.configurationDesigner.UnsetAllInteractions();
            this.configurationDesigner.ApplyTouchInteractionToAllElements();
            this.configurationDesigner.ApplyGridDragInteractionToAllElements(10, 10);
        };
        ConfigurationDesignController.prototype.CreateVirtualScreenElement = function (virtualScreenWithPos) {
            var rect = this.configurationDesigner.GetRectFromVirtualScreen(virtualScreenWithPos.VirtualScreen, new Rect_1.Rect(0, 0, 0, 30));
            rect.x = virtualScreenWithPos.X * this.configurationDesigner.FinalScale;
            rect.y = virtualScreenWithPos.Y * this.configurationDesigner.FinalScale;
            var layoutElement = this.configurationDesigner.CreateVirtualScreenContainerElement(rect, this.root, this.vsLayoutTemplate);
            if (virtualScreenWithPos.VirtualScreen.State == null)
                virtualScreenWithPos.VirtualScreen.State = "on";
            layoutElement.object = virtualScreenWithPos;
            layoutElement.UpdateStateUI();
            layoutElement.AddEventListener("SwitchStateClicked", this.SwitchStateClicked.bind(this));
            this.virtualScreenElements.push(layoutElement);
            this.LoadConfigurationContent(layoutElement);
        };
        ConfigurationDesignController.prototype.ChangeVirtualScreenScale = function (scale) {
            this.configurationDesigner.ScaleRatio = scale;
            for (var _i = 0, _a = this.virtualScreenElements; _i < _a.length; _i++) {
                var layoutElement = _a[_i];
                var virtualScreenWithPos = layoutElement.object;
                var rect = this.configurationDesigner.GetRectFromVirtualScreen(virtualScreenWithPos.VirtualScreen, new Rect_1.Rect(0, 0, 0, 30));
                rect.x = virtualScreenWithPos.X * this.configurationDesigner.FinalScale;
                rect.y = virtualScreenWithPos.Y * this.configurationDesigner.FinalScale;
                layoutElement.SetSize(rect.width, rect.height);
                layoutElement.SetPosition(rect.x, rect.y);
            }
            this.configurationDesigner.RecalculateElementsTransform();
        };
        ConfigurationDesignController.prototype.CreateNewVirtualScreenElement = function (sender, data) {
            if (this.debug)
                console.log("CreateNewVirtualScreenElement");
            var event = data.event;
            var vsLayoutElement = data.layoutElement;
            var virtualScreen = vsLayoutElement.object;
            var rect = this.configurationDesigner.GetRectFromVirtualScreen(virtualScreen, new Rect_1.Rect(0, 0, 0, 30));
            rect.x = 0;
            rect.y = 0;
            var layoutElement = this.configurationDesigner.CreateVirtualScreenContainerElement(rect, this.root, this.vsLayoutTemplate);
            layoutElement.DeParent();
            var virtualScreenWithPos = new RoomOverview_3.VirtualScreenWithPosition();
            virtualScreenWithPos.VirtualScreen = virtualScreen;
            virtualScreenWithPos.VirtualScreenId = virtualScreen.Id;
            layoutElement.object = virtualScreenWithPos;
            layoutElement.UpdateStateUI();
            this.virtualScreenElements.push(layoutElement);
            this.configurationDesigner.UnsetAllInteractions();
            this.configurationDesigner.ApplyGridDragInteractionToAllElements(10, 10);
            this.configurationDesigner.ApplyResizeInteractionToAllElements();
            this.configurationDesigner.ApplyTouchInteractionToAllElements();
            var clientRect = vsLayoutElement.GetRect();
            var rootRect = interact("#contentWorkSpace").getRect();
            var posX = event.pageX - (layoutElement.width.toNumber() / 2);
            var posY = event.pageY - 15;
            layoutElement.SetPosition(posX, posY);
            layoutElement.StartInteraction("drag", data.event.interaction);
            this.LoadConfigurationContent(layoutElement);
            vsLayoutElement.Hide();
        };
        ConfigurationDesignController.prototype.SwitchStateClicked = function (element) {
            this.SaveVirtualScreens();
            this.SaveRoomOverview();
        };
        ConfigurationDesignController.prototype.ShowVirtualScreenElement = function (layoutElement) {
            var virtualScreen = layoutElement.object.VirtualScreen;
            var vsElement = this.virtualScreenLayoutDesigner.GetElementWithSameId(virtualScreen);
            if (vsElement != null)
                vsElement.Show();
        };
        ConfigurationDesignController.prototype.LoadConfigurationContent = function (layoutElement) {
            var virtualScreen = layoutElement.object.VirtualScreen;
            this.configurationDesigner.CreateContentRecursively(virtualScreen, virtualScreen, layoutElement);
        };
        ConfigurationDesignController.prototype.ElementTouched = function (sender, data) {
            if (this.debug)
                console.log("ElementTouched");
            var layoutElement = data.layoutElement;
            var virtualScreen = layoutElement.object.VirtualScreen;
            this.SetInfoGui(virtualScreen);
        };
        ConfigurationDesignController.prototype.ElementDropped = function (sender, data) {
            if (this.debug)
                console.log("ElementDropped");
            var layoutElement = data.layoutElement;
            if (layoutElement.element.parent()[0].tagName.toLowerCase() == "body") {
                if (this.configurationDesigner.ElementIsInDropzone == false) {
                    this.ShowVirtualScreenElement(layoutElement);
                    this.configurationDesigner.DeleteLayoutElementRecursively(layoutElement);
                    var index = this.virtualScreenElements.indexOf(layoutElement);
                    if (index != -1) {
                        this.virtualScreenElements.splice(index, 1);
                    }
                    return;
                }
                layoutElement.Parent();
                var rootRect = interact("#contentWorkSpace").getRect();
                var posX = layoutElement.x - rootRect.left;
                var posY = layoutElement.y - rootRect.top;
                layoutElement.SetPosition(posX, posY);
            }
            var virtualScreenWithPos = layoutElement.object;
            var virtualScreen = virtualScreenWithPos.VirtualScreen;
            virtualScreenWithPos.X = Math.round(layoutElement.x * this.configurationDesigner.FinalScale);
            virtualScreenWithPos.Y = Math.round(layoutElement.y * this.configurationDesigner.FinalScale);
            this.SetInfoGui(virtualScreen);
            this.ExtendWorkspace(this.addWorkspaceWidth, this.addWorkspaceHeight, true);
            this.configurationDesigner.UnsetAllInteractions();
            this.configurationDesigner.ApplyTouchInteractionToAllElements();
            this.configurationDesigner.ApplyGridDragInteractionToAllElements(10, 10);
            this.SetVirtualScreenCanvasVisibility();
        };
        ConfigurationDesignController.prototype.ElementMoved = function (sender, data) {
            var id = data.layoutId;
            this.ExtendWorkspace(this.addWorkspaceWidth, this.addWorkspaceHeight);
        };
        ConfigurationDesignController.prototype.ExtendWorkspace = function (addWidth, addHeight, fitSize) {
            if (fitSize === void 0) { fitSize = false; }
            var bBox = this.GetBoundingBox();
            if (bBox == null)
                return;
            var newWorkspaceWidth = bBox.width + bBox.min.x + addWidth;
            if (newWorkspaceWidth < this.minWorkspaceWidth)
                newWorkspaceWidth = this.minWorkspaceWidth;
            var newWorkspaceHeight = bBox.height + bBox.min.y + addHeight;
            if (newWorkspaceHeight < this.minWorkspaceHeight)
                newWorkspaceHeight = this.minWorkspaceHeight;
            if (newWorkspaceWidth > this.currentWorkspaceMaxWidth || fitSize) {
                this.root.width(newWorkspaceWidth);
                this.currentWorkspaceMaxWidth = newWorkspaceWidth;
            }
            if (newWorkspaceHeight > this.currentWorkspaceMaxHeight || fitSize) {
                this.root.height(newWorkspaceHeight);
                this.currentWorkspaceMaxHeight = newWorkspaceHeight;
            }
        };
        ConfigurationDesignController.prototype.GetVsDimensionText = function (virtualScreen) {
            return Math.round(virtualScreen.Dimension.Width) + " x " + Math.round(virtualScreen.Dimension.Height) + " mm";
        };
        ConfigurationDesignController.prototype.SetInfoGui = function (virtualScreen) {
            this.headerVm.vsName = virtualScreen.Name;
            this.headerVm.vsDimension = this.GetVsDimensionText(virtualScreen);
            this.headerVm.vsComment = virtualScreen.Commect;
        };
        ConfigurationDesignController.prototype.SetCommonGui = function (virtualScreens) {
            if (virtualScreens != null)
                this.headerVm.vsCount = virtualScreens.length;
        };
        ConfigurationDesignController.prototype.ElementEdit = function (sender, data) {
            if (this.debug)
                console.log("ElementEdit");
            var contentElement = data.contentElement;
            var contentSelection = new ContentSelectionController_1.ContentSelectionController();
            var host = this;
            contentSelection.AddEventListener(ContentSelectionController_1.ContentSelectionControllerEventTypes.contentSelected, function (sender, data) {
                host.configurationDesigner.SetContent(data, contentElement);
                host.configurationDesigner.UnsetAllInteractions();
                host.configurationDesigner.ApplyTouchInteractionToAllElements();
                host.configurationDesigner.ApplyGridDragInteractionToAllElements(10, 10);
            });
        };
        return ConfigurationDesignController;
    }(EventEmitter_1.EventEmitter));
    $(function () {
        if ($("#contentEditorUI").length > 0) {
            var configurationDesignController = new ConfigurationDesignController(window["assignedLocation"], window["roomId"]);
        }
    });
});
//# sourceMappingURL=ConfigurationDesignController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/ConfigurationDesignController.js
// module id = 386
// module chunks = 0